import { apiUrl } from '../config/api'

export async function listFeatures(clientId) {
  let params = {
    clientId: clientId
  }

  let url = apiUrl('ListAssignedFeaturesByClient')

  return sendReq(params, url)
}

export async function listFeatureLabels(clientId, featureName) {
  let params = {
    clientId: clientId,
    featureName: featureName
  }

  let url = apiUrl('ListFeatureLabels')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, { method: 'POST', body: JSON.stringify(params) })
  return res.json()
}
